import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { GetDelegationList } from "../Responses/GetDelegationList";



export async function getDelegationList(data) {
    let response = await getAPIResponse("/v1/delegations-list", data);
    if(response === null) {
        return null;
    }
    let getDelegationList = GetDelegationList.createFromResponseData(response);
    return getDelegationList;
}